import { ChartDonut, ChartTooltip } from "@patternfly/react-charts";
import "./LeafGreyDonutChart.scss";

const LeafGreyDonutChart = () => {
  return (
    <div className="leaf-grey-donut-chart__container">
      <div className="leaf-grey-donut-chart" data-testid="grey-chart">
        <ChartDonut
          constrainToVisibleArea={true}
          data={[{ x: "0", y: 100 }]}
          labels={({ datum }) => `${datum.x}%`}
          labelComponent={
            <ChartTooltip
              style={{ fontSize: 10 }}
              flyoutStyle={{ fill: "#000" }}
              flyoutPadding={4}
              pointerLength={0}
              constrainToVisibleArea={true}
            />
          }
          colorScale={["#F0F0F0"]}
          innerRadius={70}
          padding={{
            left: 25,
            right: 25,
          }}
        />
      </div>
    </div>
  );
};

export default LeafGreyDonutChart;
